<template>
    <div class="left">
        <!-- 左侧商城导航公共部分 -->
        <div class="mainWrap">
            <div class="mainL">
                <div class="navs">
                    <h3>个人中心</h3>
                    <ul  v-if="userInfo.userType == 2">
                        <li
                            v-for="(item,index) in grList"
                            :key="index"
                            class="shou"
                            :class="{'active':i1==index}"
                            @click="select(index,item.href)"
                        >{{item.name}}</li>
                    </ul>
                    <ul v-else>
                        <li
                            v-for="(item,index) in grList2"
                            :key="index"
                            class="shou"
                            :class="{'active':i1==index}"
                            @click="select(index,item.href)"
                        >{{item.name}}</li>
                    </ul>
                </div>
                <div class="navs" v-if="!isYS">
                    <h3>药城区</h3>
                    <ul>
                        <li
                            class="shou"
                            v-for="(item,index) in scList"
                            :key="index"
                            :class="{'active':i2==index}"
                            @click="select2(index,item.href)"
                        >{{item.name}}</li>
                    </ul>
                </div>
                <!-- 是医师，并且审核通过才显示 -->
                <!-- <div class="navs" v-if="$store.state.userInfo.userType==2">
                    <h3>医师中心</h3>
                    <ul>
                        <li
                            class="shou"
                            v-for="(item,index) in ysList"
                            :key="index"
                            :class="{'active':i3==index}"
                            @click="select3(index,item.href)"
                        >
                            <span v-if="$store.state.userInfo.userType==2&&userInfo.approvalStatus =='1'">{{item.name}}</span>
                        </li>
                    </ul>
                </div> -->
                <div class="navs">
                    <h3>设置</h3>
                    <ul>
                        <li
                            class="shou"
                            v-for="(item,index) in setUpList"
                            :key="index"
                            :class="{'active':i4==index}"
                            @click="select4(index,item.href)"
                        >{{item.name}}</li>
                    </ul>
                </div>
            </div>
            
            <div class="mainR">
                <router-view />
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "left",
    data() {
        return {
            grList: [
                { name: "个人信息", href: "/personalInformation" },
                // { name: "个人信息-医师", href: "/personalInformation" },
                { name: "我的患者", href: "/myPatients" },
                { name: "我的收藏", href: "/myCollection" }
            ],
            grList2: [
                { name: "个人信息", href: "/personalInformation" },
                { name: "我的医案/档案", href: "/myYiAn" },
                { name: "我的收藏", href: "/myCollection" }
            ],
            scList: [
                { name: "我的购物车", href: "/car" },
                { name: "我的订单", href: "/myOrder" },
                // { name: "我的发票", href: "" },
                { name: "我的地址管理", href: "/myAddress" }
            ],
            ysList: [
                { name: "医师个人中心", href: "/personalFiles" },
                { name: "我的患者", href: "/myPatients" }
            ],
            setUpList:[
                { name: "批发商信息", href: "/wholesalerInfo" },
                { name: "个人信息-医师", href: "/doctorInfo" },
            ],
            changeRed: 0,
            i1: 0,
            i2: 100,
            i3: 100,
            i4: 100,
            userInfo:null,
            userId:null
        };
    },
    created() {
        if (sessionStorage.getItem("userInfo")) {
            this.userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
            this.userId = this.userInfo.id;
        }
        var href = window.location.href.split("#")[1]; //获取当前地址
        if (href == "/PersonalCenter") {
            //如果相等默认跳转当前页
            this.i1 = 100;
            this.i2 = 100;
            this.i3 = 100;
            this.i4 = 100;
            sessionStorage.setItem("leftIndex1",100);
            sessionStorage.setItem("leftIndex2",100);
            sessionStorage.setItem("leftIndex3",100);
            sessionStorage.setItem("leftIndex4",100);
        } else{
            //不相等跳转保存的页面
            this.i1 = sessionStorage.getItem("leftIndex1");
            this.i2 = sessionStorage.getItem("leftIndex2");
            this.i3 = sessionStorage.getItem("leftIndex3");
            this.i4 = sessionStorage.getItem("leftIndex4");
        }
        if (href == "/personalInformation") {
            //如果相等默认跳转当前页
            this.i1 = 0;
            this.i2 = 100;
            this.i3 = 100;
            this.i4 = 100;
        } else {
            //不相等跳转保存的页面
            this.i1 = sessionStorage.getItem("leftIndex1");
            this.i2 = sessionStorage.getItem("leftIndex2");
            this.i3 = sessionStorage.getItem("leftIndex3");
            this.i4 = sessionStorage.getItem("leftIndex4");
        }
        this.getUserinfo();
        if (sessionStorage.getItem("YS")) {
            // this.isYS = JSON.parse(sessionStorage.getItem("YS"));
            // // console.log(this.isYS);
            // if (this.isYS) {
            //     if (!!sessionStorage.getItem("fromMessage")) {
            //         this.select3(1);
            //         sessionStorage.removeItem("fromMessage");
            //     } else {
            //         this.select3(0);
            //     }
            // }
            // if (this.$route.query.yian) {
            //     this.select(1);
            // }
        }
        if(this.$route.query.i){
            // debugger
            switch(this.$route.query.i){
                case 1:
                    this.i1 = this.$route.query.i;
                    this.i2 = 100;
                    this.i3 = 100;
                    this.i4 = 100;
                case 2:
                    this.i1 = this.$route.query.i;
                    this.i2 = 100;
                    this.i3 = 100;
                    this.i4 = 100;
            }
        }
    },
    methods: {
        handleOpen(key, keyPath) {
            // console.log(key, keyPath);
        },
        handleClose(key, keyPath) {
            // console.log(key, keyPath);
        },
        //个人中心
        select(index, href) {
            if (index == 2) {
                //如果当前项时收藏时，默认
                sessionStorage.setItem("CollectionIndex", 0); //默认显示第一个
            }
            sessionStorage.setItem("leftIndex1", index); //左侧导航位置
            sessionStorage.setItem("leftIndex2", 100); //左侧导航位置
            sessionStorage.setItem("leftIndex3", 100); //左侧导航位置
            sessionStorage.setItem("leftIndex4", 100); //左侧导航位置
            this.i1 = index;
            this.i2 = 100;
            this.i3 = 100;
            this.i4 = 100;
            this.$router.push({ path: href });
        },
        // 商城区
        select2(index, href) {
            if(index == 1){
                 //如果当前项为订单时，默认
                sessionStorage.setItem("orderIndex", 0); //默认显示第一个
            }
            sessionStorage.setItem("leftIndex1", 100); //左侧导航位置
            if(index==0){
            sessionStorage.setItem("leftIndex2", 100); //左侧导航位置
            }else{
                sessionStorage.setItem("leftIndex2", index); //左侧导航位置
            }
            sessionStorage.setItem("leftIndex3", 100); //左侧导航位置
            sessionStorage.setItem("leftIndex4", 100); //左侧导航位置
            this.i1 = 100;
            this.i3 = 100;
            this.i4 = 100;
            this.i2 = index==0?100:index;
            this.$router.push({ path: href });
        },
        //医师个人中心
        select3(index, href) {
            sessionStorage.setItem("leftIndex1", 100); //左侧导航位置
            sessionStorage.setItem("leftIndex2", 100); //左侧导航位置
            sessionStorage.setItem("leftIndex3", index); //左侧导航位置
            sessionStorage.setItem("leftIndex4", 100); //左侧导航位置
            this.i1 = 100;
            this.i2 = 100;
            this.i3 = index;
            this.i4 = 100;
            this.$router.push({ path: href });
        },
         //设置
         select4(index, href) {
            sessionStorage.setItem("leftIndex1", 100); //左侧导航位置
            sessionStorage.setItem("leftIndex2", 100); //左侧导航位置
            sessionStorage.setItem("leftIndex3", 100); //左侧导航位置
            sessionStorage.setItem("leftIndex4", index); //左侧导航位置
            this.i1 = 100;
            this.i2 = 100;
            this.i3 = 100;
            this.i4 = index;
            this.$router.push({ path: href });
        }
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/* .el-menu{
  border: solid 1px #dddddd; 
} */
.el-submenu .el-menu-item {
    padding-left: 20px !important;
}

.el-submenu .el-menu-item {
    min-width: 180px;
    height: 40px;
    line-height: 40px;
}
.big-title {
    font-size: 16px;
    font-weight: bold;
}
.header2 {
    width: 100%;
    height: 94px;
    background-color: #f64420;
}
.header2Wrap {
    max-width: 1440px;
    max-width: 80%;
    width: 1024px;
    height: 100%;
    margin: 0px auto;
}
.header2L {
    float: left;
    width: 280px;
    height: 80%;
    margin-top: 10px;
}
.header2L img {
    width: 100%;
    height: 100%;
}
.btmNav {
    width: 100%;
    height: 50px;
    background: #eee;
    border-top: 1px solid #f6f6f6;
    border-bottom: 1px solid #f6f6f6;
    margin-top: 100px;
}
.btmNav ul {
    width: 900px;
    height: 50px;
    margin: 0px auto;
}
.btmNav ul li {
    float: left;
    height: 50px;
    line-height: 50px;
    padding: 0 10px;
    margin: 0 30px;
    font-weight: 600;
    color: #666;
    cursor: pointer;
}
.mainWrap {
    max-width: 1440px;
    max-width: 80%;
    width: 1024px;
    height: 100%;
    margin: 20px auto;
}
.mainWrap::after {
    content: "";
    display: block;
    clear: both;
    height: 0;
    visibility: hidden;
    overflow: hidden;
}
.mainL {
    float: left;
    width: 160px;
    height: 545px;
    background-color: #ffffff;
    border: solid 1px #dddddd;
}
.navs {
    width: 100%;
}
.navs::after {
    content: "";
    display: block;
    clear: both;
    height: 0;
    visibility: hidden;
    overflow: hidden;
}
.navs h3 {
    font-size: 16px;
    font-weight: bold;
    font-stretch: normal;
    line-height: 23px;
    letter-spacing: 1px;
    color: #333333;
    text-indent: 30px;
    margin-top: 40px;
}
.navs ul {
    width: 100%;
    font-family: MicrosoftYaHei;
    font-size: 14px;
    line-height: 23px;
    letter-spacing: 1px;
    color: #666666;
}
.navs ul li {
    width: 100%;
    text-indent: 30px;
}
.navs ul li.active {
    color: #f64420;
    border-left: 3px solid #f64420;
}
.mainR {
    float: right;
    width: 82.5%;
    /* height: 545px; */
    overflow-y: auto;
    margin-bottom:30px;
}
/* 底部  */
.foot {
    width: 100%;
    height: 30px;
    font-size: 12px;
    line-height: 30px;
    letter-spacing: 1px;
    color: #999999;
    text-align: center;
    border: 1px solid #ddd;
    margin-top: 60px;
}
</style>

<style scoped>
#Shopping {
    background: #fbfbfb;
}
.bottomW {
    background-color: #fbfbfb;
}
/* 上方商品分类选项 */
.topList {
    width: 100%;
    height: 40px;
    border-bottom: 1px solid #ccc;
}
.topList h3 {
    float: left;
    width: 150px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    color: #fff;
    background: #ffa42f;
    margin: 0;
    cursor: pointer;
    position: relative;
}
.topList-list {
    width: 150px;
    min-height: 350px;
    max-height: 500px;
    background: rgba(0, 0, 0, 0.5);
    position: absolute;
    z-index: 999;
    overflow-y: auto;
}
.topList-list ul {
    width: 100%;
    box-sizing: border-box;
    padding: 10px 20px;
}
.topList-list ul li {
    width: 100%;
    height: 35px;
    line-height: 35px;
    color: #fff;
    font-size: 16px;
    font-weight: 100;
    border-bottom: 1px dashed #999;
}
.topList-list ul li span {
    height: 35px;
    line-height: 35px;
    display: block;
    width: 90%;
    float: left;
    text-align: left;
}
.topList-list ul li i {
    height: 35px;
    line-height: 35px;
    display: block;
    width: 10%;
    float: left;
}
.topList .nav {
    float: left;
    width: 80%;
    height: 40px;
    line-height: 40px;
    text-align: center;
    letter-spacing: 1px;
    color: #666666;
}
.topList .nav li {
    float: left;
    padding: 0 10px;
    cursor: pointer;
}
/* 主题内容 */
.main {
    width: 100%;
    margin: 0px auto;
}
.main::after {
    content: "";
    height: 0;
    clear: both;
    overflow: hidden;
    display: block;
    visibility: hidden;
}
/* 商品列表样式 */
.Product1,
.Product2 {
    width: 100%;
}
.Product1::after {
    content: "";
    display: block;
    visibility: hidden;
    height: 0;
    clear: both;
}
.Product2::after {
    content: "";
    display: block;
    visibility: hidden;
    height: 0;
    clear: both;
}
.ProductList {
    float: left;
    width: 24%;
    height: 340px;
    margin: 20px 13px 0 0;
}
.ProductList2 {
    float: left;
    width: 18.7%;
    height: 290px;
    margin: 15px 13px 0 0;
}
.ProductList:nth-child(4n + 4) {
    margin-right: 0;
}
.ProductList2:nth-child(4n + 4) {
    margin-right: 13px;
}
.ProductList2:nth-child(5n + 5) {
    margin-right: 0;
}
.ProductList .ProductImg {
    width: 100%;
    height: 131px;
    overflow: hidden;
}
.ProductImg img {
    width: 100%;
    min-height: 100%;
}
.Product {
    width: 100%;
    height: 35%;
    background: #fff;
    margin-top: 10px;
}
.Product .p1 {
    width: 100%;
    height: 25px;
    line-height: 25px;
    font-size: 14px;
}
.Product .p1 .tit {
    display: block;
    float: left;
    width: 70%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: #909090;
}
.Product .p1 .tit2 {
    display: block;
    float: right;
    height: 15px;
    line-height: 15px;
    width: 35px;
    text-align: center;
    border: 1px solid #f74320;
    background: #ffece8;
    margin-right: 10px;
    color: #f74320;
}
.Product .p1 .tit22 {
    border: 1px solid #64b9f2;
    background: #e8f7fe;
    color: #64b9f2;
}
.Product .p2 {
    height: 40px;
    line-height: 20px;
    color: #666;
    margin-top: 5px;
    display: -webkit-box;
    overflow: hidden;
    white-space: normal !important;
    text-overflow: ellipsis;
    word-wrap: break-word;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
}
.Product .p3 {
    width: 100%;
    height: 25px;
    /* margin-top: 20px; */
}
.Product .p3 .money {
    float: left;
    width: 80%!important ;
    /* text-indent: 10px; */
}
.p3 .money span {
    color: #f74320;
    font-size: 25px;
    font-weight: 600;
}
.p3 .money i {
    color: #999;
    font-size: 14px;
    font-style: normal;
}
.Product .p3 .car {
    float: right;
    width: 25px;
    height: 25px;
    line-height: 25px;
    text-align: center;
    margin-right: 20px;
    background: #f74320;
    color: #fff;
    border-radius: 50%;
    cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/common/left.vue